// store/index.js —— Vuex 全局状态仓库
// 用 Vuex 替代小程序的 mobx-miniprogram，承载跨页面共享的登录态、当前单词、已选课本
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 当前查询/浏览的单词（跨页面：查词、看图、视频、课本点选联动）
    word: 'hello',
    // 登录 token（satoken），持久化到 localStorage
    token: localStorage.getItem('satoken') || '',
    // 当前登录用户信息（可能含 selectBook 字段）
    teacherInfo: null,
    // 当前已选课本四元组（如 "外研版三起点(2024)|小学|三年级|上册"）
    selectBook: localStorage.getItem('selectBook') || ''
  },
  getters: {
    isLogin: (state) => !!state.token
  },
  mutations: {
    setWord(state, word) {
      state.word = word
      // 记录搜索历史（去重，保留最近 20 条），供个人中心展示最近查词
      if (word) {
        try {
          const history = JSON.parse(localStorage.getItem('searchHistory') || '[]')
          const idx = history.indexOf(word)
          if (idx > -1) history.splice(idx, 1)
          history.unshift(word)
          localStorage.setItem('searchHistory', JSON.stringify(history.slice(0, 20)))
          if (!localStorage.getItem('firstUseAt')) {
            localStorage.setItem('firstUseAt', String(Date.now()))
          }
        } catch (e) {
          /* 忽略本地存储异常 */
        }
      }
    },
    setToken(state, token) {
      state.token = token || ''
      if (token) localStorage.setItem('satoken', token)
      else localStorage.removeItem('satoken')
    },
    setTeacherInfo(state, info) {
      state.teacherInfo = info
    },
    setSelectBook(state, sel) {
      state.selectBook = sel || ''
      if (sel) localStorage.setItem('selectBook', sel)
      else localStorage.removeItem('selectBook')
      if (state.teacherInfo) {
        state.teacherInfo.selectBook = sel || ''
      }
    },
    setLoginData(state, { token, info }) {
      state.token = token || ''
      state.teacherInfo = info || null
      state.selectBook = (info && info.selectBook) || ''
      if (token) localStorage.setItem('satoken', token)
      if (state.selectBook) localStorage.setItem('selectBook', state.selectBook)
    },
    clearLogin(state) {
      state.token = ''
      state.teacherInfo = null
      state.selectBook = ''
      localStorage.removeItem('satoken')
      localStorage.removeItem('selectBook')
    }
  },
  actions: {
    setWord({ commit }, word) {
      commit('setWord', word)
    },
    setLoginData({ commit }, payload) {
      commit('setLoginData', payload)
    },
    setSelectBook({ commit }, sel) {
      commit('setSelectBook', sel)
    },
    clearLogin({ commit }) {
      commit('clearLogin')
    }
  }
})
